import { useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import BaseRoute from './BaseRoute';
import AuthRoutes from './AuthRoutes';

// ==============================|| ROUTING RENDER ||============================== //
// *** IMPORTANT ***
// The MainRoutes component must be placed at the beginning of the routes array, otherwise the theme will fail to load

export default function ThemeRoutes() {
    return useRoutes([MainRoutes, BaseRoute, AuthRoutes]);
}
